module.exports = __webpack_public_path__ + "img/dhdt.cb73e309.png";